import { render, staticRenderFns } from "./DomainUser.vue?vue&type=template&id=7b88d3ce&"
import script from "./DomainUser.vue?vue&type=script&lang=js&"
export * from "./DomainUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports